import { MldEcommerceEventParams } from '../events'
import { CartProductItem } from '../types'

export type CartProductItemForEcommerce = Pick<
  CartProductItem,
  | 'id'
  | 'name'
  | 'organization'
  | 'price'
  | 'discountPrice'
  | 'brand'
  | 'category'
  | 'subCategory'
  | 'category3'
  | 'category4'
  | 'category5'
  | 'variant'
  | 'locationId'
  | 'status'
  | 'quantity'
>

export const formatCartItemsToEcommerce = (
  items: CartProductItemForEcommerce[],
  parameters?: MldEcommerceEventParams['parameters'],
) =>
  items.map((item, index) => ({
    item_id: item.id,
    item_name: item.name,
    coupon: parameters?.coupon,
    discount: calculateDiscount(Number(item.price ?? 0), Number(item.discountPrice ?? 0)),
    index,
    item_brand: item.brand,
    item_category: item.category,
    item_category2: item.subCategory,
    item_category3: item.category3,
    item_category4: item.category4,
    item_category5: item.category5,
    item_list_id: parameters?.item_list_id,
    item_list_name: parameters?.item_list_name,
    cd_pagina: parameters?.cd_pagina,
    cd_product_status: item.status,
    item_variant: item.variant,
    location_id: item.locationId,
    price: item.price,
    quantity: item.quantity,
  }))

const calculateDiscount = (price: number, discountPrice: number) => {
  const discount = price - discountPrice
  return discount > 0 ? discount : 0
}
